import { createContext, useContext, useState, useEffect } from 'react'
import { login as apiLogin, logout as apiLogout, isLoggedIn, getUser } from '../lib/api'
import { useTenant } from '../../platform/tenant/TenantContext'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const { tenant } = useTenant()
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (isLoggedIn()) {
      setUser(getUser())
    }
    setLoading(false)
  }, [])

  const login = async (email, password, tenant_id = tenant?.id) => {
    try {
      const data = await apiLogin(email, password, tenant_id)
      if (data.ok) {
        // IMMEDIATELY set user state synchronously for demo
        setUser(data.user)
        // Force re-render by waiting one tick
        await new Promise(resolve => setTimeout(resolve, 50))
        return { success: true }
      }
      return { success: false, error: 'Login failed' }
    } catch (error) {
      return { success: false, error: error.message }
    }
  }

  const logout = () => {
    apiLogout()
    setUser(null)
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, isAuthenticated: !!user, loading }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}